// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__k3XvP","remainingPts":"Footer_remainingPts__8r_t2","skillUpBtn":"Footer_skillUpBtn__azcyS"};